﻿import {useState} from "react";
import {useScrollPassive} from "./scroll/useScrollPassive";

const useSticky = () => {
  const [isSticky, setIsSticky] = useState(false);


  useScrollPassive(() => {
    if (window.scrollY > 30) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  }, [setIsSticky]);

  return {
    isSticky
  }
}

export { useSticky };
